module.exports = __webpack_public_path__ + "img/logo-ESF-1-500x233.5186d897.jpg";